module.exports = __webpack_public_path__ + "img/car-empty.52d97c0e.svg";